export default __webpack_public_path__ + "static/media/KOD0044-min.a1b28dc8.webp";